var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-pdv btn-pdv-blue mr-1",attrs:{"type":"button","href":"javascript: void(0);"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('i',{staticClass:"fe-filter mr-1"}),_vm._v(" "+_vm._s(_vm.getI18nModified({ prefix: 'COMMON', suffix: 'filter', modifier: 2 }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }